const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);

// FIX-35: Only allow safe URI schemes for images
const SAFE_DATA_URI_PATTERN = /^data:image\/(jpeg|jpg|png|gif|webp);base64,[a-zA-Z0-9+/]+=*$/;

export function resolveImageUrl(value, fallback = '/web-logo.jpg') {
  if (!value || typeof value !== 'string') {
    return fallback;
  }

  // Allow http/https absolute URLs
  if (isAbsoluteUrl(value)) {
    return value;
  }

  // FIX-35: Only allow data: URIs with image MIME types (prevent XSS via data:text/html)
  if (value.startsWith('data:')) {
    if (SAFE_DATA_URI_PATTERN.test(value)) {
      return value;
    }
    return fallback;
  }

  // Allow blob: URIs (created by browser APIs, safe for images)
  if (value.startsWith('blob:')) {
    return value;
  }

  if (value.startsWith('/')) {
    return value;
  }

  return `/${value.replace(/^public\//, '')}`;
}

export default resolveImageUrl;
